import {
  cacheExchange,
  createClient,
  dedupExchange,
  fetchExchange,
  Provider,
} from "urql";
import { Header } from "./components/Header";

import "@szhsin/react-menu/dist/index.css";
import "./styles/global.scss";
const client = createClient({
  url: "https://graphql.curnonwatch.com/curnon/graphql",
});
export function App() {
  return (
    <Provider value={client}>
      <Header></Header>
    </Provider>
  );
}
